import { createFileRoute } from '@tanstack/react-router'
import { Container } from '@/components/ui/Container'
import { Button } from '@/components/ui/Button'
import {
  BookOpen,
  Phone,
  ArrowRight,
  Award,
  Users,
  Target,
  Check,
  X,
  GraduationCap
} from 'lucide-react'
import { generateWhatsAppLink } from '@/lib/utils/whatsapp'

const packages = [
  {
    title: 'Paket Basic',
    subtitle: 'Cocok untuk penulis pemula',
    price: 750000,
    originalPrice: 1000000,
    description: 'Paket penerbitan dasar dengan layanan lengkap untuk buku pertama Anda.',
    features: [
      { included: true, text: 'Bukti cetak 6 eks' },
      { included: true, text: 'Proofreading' },
      { included: true, text: 'Cover dan layout' },
      { included: true, text: 'ISBN gratis' },
      { included: true, text: 'Promosi Media Sosial' },
      { included: true, text: 'Publikasi Google Playbook' },
      { included: true, text: 'Publikasi Google Scholar' },
      { included: true, text: 'Sertfikat penulis' },
      { included: true, text: 'Royalti penjualan' },
      { included: false, text: 'Free HKI' },
      { included: false, text: 'Edit Naskah' },
    ]
  },
  {
    title: 'Paket Medium',
    subtitle: 'Pilihan terpopuler',
    price: 1250000,
    originalPrice: 1500000,
    description: 'Paket lengkap dengan kualitas premium untuk buku profesional.',
    features: [
      { included: true, text: 'Bukti cetak 20 eks' },
      { included: true, text: 'Proofreading' },
      { included: true, text: 'Cover dan layout' },
      { included: true, text: 'ISBN gratis' },
      { included: true, text: 'Promosi Media Sosial' },
      { included: true, text: 'Publikasi Google Playbook' },
      { included: true, text: 'Publikasi Google Scholar' },
      { included: true, text: 'Sertfikat penulis' },
      { included: true, text: 'Royalti penjualan' },
        { included: false, text: 'Free HKI' },
      { included: false, text: 'Edit Naskah' },
    ],
    recommended: true,
    badge: 'Terlaris'
  },
  {
    title: 'Paket Premium',
    subtitle: 'Untuk profesional',
    price: 2000000,
    originalPrice: 2500000,
    description: 'Paket all-inclusive dengan layanan VIP dan distribusi lengkap.',
    features: [
      { included: true, text: 'Bukti cetak 50 eks' },
      { included: true, text: 'Proofreading' },
      { included: true, text: 'Cover dan layout' },
      { included: true, text: 'ISBN gratis' },
      { included: true, text: 'Promosi Media Sosial' },
      { included: true, text: 'Publikasi Google Playbook' },
      { included: true, text: 'Publikasi Google Scholar' },
      { included: true, text: 'Sertfikat penulis' },
      { included: true, text: 'Royalti penjualan' },
      { included: true, text: 'Free HKI' },
      { included: true, text: 'Edit Naskah' },

    ]
  }
]

// Paket Buku Ajar - Data dari gambar
const textbookPackages = [
  {
    title: 'Paket Mandiri',
    subtitle: 'Naskah sudah berbentuk buku ajar utuh',
    priceA5: 1000000,
    priceUnesco: 1150000,
    description: 'Editor berperan sebagai penyempurna bahasa, teknis, dan tata letak.',
    features: [
      { text: 'Cover & Layout' },
      { text: 'Edit dan Proofreading' },
      { text: 'ISBN' },
      { text: 'Cetak 10 eks' },
      { text: 'Royalty penjualan' },
      { text: 'Indeks google scholar' },
      { text: 'Sertifikat penulis' },
      { text: 'Gratis e-book' },
      { text: 'Mockup promosi' },
      { text: 'Promosi Media Sosial' },
    ],
    hkiUpgrade: 300000,
  },
  {
    title: 'Paket Prima',
    subtitle: 'Naskah dapat berupa RPS dan kumpulan materi',
    priceA5: 2000000,
    priceUnesco: 2150000,
    description: 'Editor mendampingi penyusunan struktur buku ajar hingga layak terbit.',
    features: [
      { text: 'Cover & Layout' },
      { text: 'Edit dan Proofreading' },
      { text: 'ISBN' },
      { text: 'Cetak 10 eks' },
      { text: 'Royalty penjualan' },
      { text: 'Indeks google scholar' },
      { text: 'Sertifikat penulis' },
      { text: 'Gratis e-book' },
      { text: 'Mockup promosi' },
      { text: 'Promosi Media Sosial' },
    ],
    hkiUpgrade: 300000,
    recommended: true,
    badge: 'Terpopuler'
  },
  {
    title: 'Paket Tuntas',
    subtitle: 'Naskah cukup berupa RPS saja',
    priceA5: 3000000,
    priceUnesco: 3150000,
    description: 'Penerbit membantu merancang buku ajar dari tahap perencanaan hingga siap terbit sesuai standar akademik.',
    features: [
      { text: 'Cover & Layout' },
      { text: 'Edit dan Proofreading' },
      { text: 'ISBN' },
      { text: 'Cetak 10 eks' },
      { text: 'Royalty penjualan' },
      { text: 'Indeks google scholar' },
      { text: 'Sertifikat penulis' },
      { text: 'Gratis e-book' },
      { text: 'Mockup promosi' },
      { text: 'Promosi Media Sosial' },
    ],
    hkiUpgrade: 300000,
    badge: 'Full Service'
  }
]

const steps = [
  {
    title: 'Konsultasi & Review',
    description: 'Diskusi awal untuk memahami kebutuhan Anda. Kami menganalisis naskah dan merekomendasikan paket terbaik.'
  },
  {
    title: 'Editing & Layout',
    description: 'Proofreading, copyediting, dan typesetting. Desain cover juga difinalisasi pada tahap ini.'
  },
  {
    title: 'ISBN & Legal',
    description: 'Kami mengurus registrasi ISBN dan deposit Perpustakaan Nasional sesuai regulasi.'
  },
  {
    title: 'Produksi & Cetak',
    description: 'Approval proof final diikuti dengan pencetakan dan pengiriman ke Anda atau distributor.'
  }
]

const benefits = [
  { icon: Award, title: 'Tim Profesional', description: 'Editor dan desainer berpengalaman lebih dari 10 tahun.' },
  { icon: Target, title: '100% Legal', description: 'ISBN resmi dan legal deposit sesuai peraturan.' },
  { icon: Users, title: 'Author Support', description: 'Konsultasi berkelanjutan hingga buku terbit.' }
]

function formatPrice(price: number) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(price)
}

export const Route = createFileRoute('/penerbitan/')({
  component: Penerbitan,
  head: () => ({
    title: 'Jasa Penerbitan Buku - Pustaka Pranala',
    meta: [{ name: 'description', content: 'Layanan penerbitan buku profesional dengan 3 paket pilihan.' }],
  }),
})

function Penerbitan() {
  const handlePackageOrder = (title: string, price: number, size?: string) => {
    const sizeInfo = size ? ` (${size})` : ''
    const message = `Halo, saya tertarik dengan ${title}${sizeInfo} (${formatPrice(price)}). Mohon info lebih lanjut. Terima kasih!`
    window.open(generateWhatsAppLink(message), '_blank')
  }

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-brand-slate-800 py-16 lg:py-20">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-yellow-400 rounded-full blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-slate-700 rounded-full blur-3xl" />
        </div>
        <Container className="relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-brand-yellow-300 text-xs font-medium tracking-wide mb-6">
              <BookOpen className="w-4 h-4" />
              LAYANAN PENERBITAN
            </div>
            <h1 className="text-3xl md:text-4xl text-white tracking-tight mb-4">
              Jasa Penerbitan Buku
              <span className="text-brand-yellow-400"> Profesional</span>
            </h1>
            <p className="text-base text-brand-slate-400 max-w-2xl mx-auto">
              Wujudkan buku impian Anda dengan layanan penerbitan terpercaya.
              Dari naskah mentah hingga buku siap jual.
            </p>
          </div>
        </Container>
      </div>

      <Container className="py-16 max-w-7xl mx-auto">
        {/* Pricing Packages - Umum */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs font-medium tracking-wide mb-4">
              PILIH PAKET
            </div>
            <h2 className="text-3xl font-semibold text-neutral-900 tracking-tight mb-4">
              Paket Penerbitan Umum
            </h2>
            <p className="text-neutral-500 max-w-2xl mx-auto">
              Tersedia 3 paket penerbitan yang dapat disesuaikan dengan kebutuhan dan budget Anda
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {packages.map((pkg) => (
              <div
                key={pkg.title}
                className={`relative bg-white border rounded-xl p-6 transition-all duration-300 hover:shadow-lg ${
                  pkg.recommended ? 'border-brand-yellow-400 ring-1 ring-brand-yellow-400' : 'border-brand-slate-200'
                }`}
              >
                {pkg.badge && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="bg-brand-yellow-400 text-brand-slate-900 text-xs font-semibold px-3 py-1 rounded-full">
                      {pkg.badge}
                    </span>
                  </div>
                )}

                <div className="text-center mb-4">
                  <h3 className="text-lg font-semibold text-brand-slate-800">{pkg.title}</h3>
                  <p className="text-sm text-brand-slate-500 mt-1">{pkg.subtitle}</p>
                </div>

                <div className="text-center mb-4">
                  <div className="text-2xl font-bold text-brand-slate-900">{formatPrice(pkg.price)}</div>
                  {pkg.originalPrice && (
                    <div className="text-xs text-brand-slate-400 line-through">{formatPrice(pkg.originalPrice)}</div>
                  )}
                </div>

                <p className="text-sm text-brand-slate-600 mb-4 text-center">{pkg.description}</p>

                <div className="space-y-2 mb-6">
                  {pkg.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-2 text-sm">
                      {feature.included ? (
                        <Check className="w-4 h-4 text-brand-yellow-500 mt-0.5 shrink-0" />
                      ) : (
                        <X className="w-4 h-4 text-brand-slate-300 mt-0.5 shrink-0" />
                      )}
                      <span className={feature.included ? 'text-brand-slate-700' : 'text-brand-slate-400 line-through'}>
                        {feature.text}
                      </span>
                    </div>
                  ))}
                </div>

                <Button
                  onClick={() => handlePackageOrder(pkg.title, pkg.price)}
                  className={`w-full h-10 cursor-pointer ${
                    pkg.recommended
                      ? 'bg-brand-yellow-400 hover:bg-brand-yellow-500 text-brand-slate-900'
                      : 'bg-brand-slate-800 hover:bg-brand-slate-900 text-white'
                  } font-medium rounded-lg text-sm border-0`}
                >
                  Pilih Paket
                </Button>
              </div>
            ))}
          </div>
        </div>

        {/* Pricing Packages - Buku Ajar */}
        <div className="mb-16 pt-8 border-t border-neutral-200">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs font-medium tracking-wide mb-4">
              <GraduationCap className="w-4 h-4" />
              KHUSUS DOSEN & GURU
            </div>
            <h2 className="text-3xl font-semibold text-neutral-900 tracking-tight mb-4">
              Paket Penerbitan Buku Ajar
            </h2>
            <p className="text-neutral-500 max-w-2xl mx-auto">
              Solusi lengkap untuk penerbitan buku ajar dan buku teks akademik<br/> dengan standar internasional
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {textbookPackages.map((pkg) => (
              <div
                key={pkg.title}
                className={`relative bg-white border rounded-xl p-6 transition-all duration-300 hover:shadow-lg ${
                  pkg.recommended ? 'border-brand-yellow-400 ring-1 ring-brand-yellow-400' : 'border-brand-slate-200'
                }`}
              >
                {/* HKI Upgrade Badge - Sticker Style */}
                <div className="absolute -top-4 -right-4 z-10">
                  <div className="bg-linear-to-br from-brand-yellow-400 to-brand-yellow-500 text-brand-slate-900 text-[10px] font-bold px-3 py-2 rounded-full shadow-lg transform rotate-12 border-2 border-white w-20 h-20 flex flex-col items-center justify-center text-center leading-tight">
                    <span className="opacity-75">Upgrade</span>
                    <span className="text-lg leading-none">+ HKI</span>
                    <span className="text-brand-slate-700 text-[9px]">CUMA</span>
                    <span className="text-sm font-bold">{formatPrice(pkg.hkiUpgrade).replace('Rp ', '').replace('Rp', '')}</span>
                  </div>
                </div>

                {pkg.badge && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className={`text-brand-slate-900 text-xs font-semibold px-3 py-1 rounded-full ${
                      pkg.recommended ? 'bg-brand-yellow-400' : 'bg-brand-slate-600 text-white'
                    }`}>
                      {pkg.badge}
                    </span>
                  </div>
                )}

                <div className="text-center mb-4 pt-2">
                  <h3 className="text-lg font-semibold text-brand-slate-800">{pkg.title}</h3>
                  <p className="text-sm text-brand-slate-500 mt-1">{pkg.subtitle}</p>
                </div>

                {/* Dual Pricing Display */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-center justify-between bg-brand-slate-50 rounded-lg p-3">
                    <div className="flex items-center gap-2">
                      <span className="bg-brand-slate-200 text-brand-slate-700 text-xs font-semibold px-2 py-1 rounded">A5</span>
                      <span className="text-xs text-brand-slate-500">Standar</span>
                    </div>
                    <span className="text-base font-bold text-brand-slate-900">{formatPrice(pkg.priceA5)}</span>
                  </div>
                  <div className="flex items-center justify-between bg-brand-yellow-50 rounded-lg p-3">
                    <div className="flex items-center gap-2">
                      <span className="bg-brand-yellow-200 text-brand-yellow-800 text-xs font-semibold px-2 py-1 rounded">UNESCO</span>
                      <span className="text-xs text-brand-yellow-700">Internasional</span>
                    </div>
                    <span className="text-base font-bold text-brand-yellow-700">{formatPrice(pkg.priceUnesco)}</span>
                  </div>
                </div>

                <div className="bg-brand-yellow-50/50 border border-brand-yellow-100 rounded-lg p-3 mb-4">
                  <p className="text-xs text-brand-yellow-800 text-center font-medium">
                    {pkg.description}
                  </p>
                </div>

                <div className="space-y-2 mb-4">
                  {pkg.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-2 text-sm">
                      <Check className={`w-4 h-4 mt-0.5 shrink-0 ${pkg.recommended ? 'text-brand-yellow-500' : 'text-brand-slate-500'}`} />
                      <span className="text-brand-slate-700">{feature.text}</span>
                    </div>
                  ))}
                </div>

                <div className="space-y-2">
                  <Button
                    onClick={() => handlePackageOrder(pkg.title, pkg.priceA5, 'A5')}
                    className={`w-full h-10 cursor-pointer ${
                      pkg.recommended
                        ? 'bg-brand-yellow-400 hover:bg-brand-yellow-500 text-brand-slate-900'
                        : 'bg-brand-slate-800 hover:bg-brand-slate-900 text-white'
                    } font-medium rounded-lg text-sm border-0`}
                  >
                    Pilih Ukuran A5
                  </Button>
                  <Button
                    onClick={() => handlePackageOrder(pkg.title, pkg.priceUnesco, 'UNESCO')}
                    variant="outline"
                    className={`w-full h-10 cursor-pointer font-medium rounded-lg text-sm ${
                      pkg.recommended
                        ? 'border-brand-yellow-400 text-brand-yellow-700 hover:bg-brand-yellow-50'
                        : 'border-brand-slate-300 text-brand-slate-700 hover:bg-brand-slate-50'
                    }`}
                  >
                    Pilih Ukuran UNESCO
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Process Section - Redesigned */}
        <section className="py-24 px-6 bg-neutral-50 -mx-3">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
              {/* Left Column - Heading */}
              <div>
                <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6">
                  Dari naskah<br />ke rak buku.
                </h2>
                <p className="text-neutral-500 mb-8">
                  Proses kami memastikan karya intelektual Anda ditangani dengan cermat dan profesionalisme.
                </p>

                <a
                  href="/kontak"
                  className="inline-flex items-center gap-2 text-sm font-medium text-neutral-900 hover:gap-3 transition-all group"
                >
                  Mulai Konsultasi
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </a>
              </div>

              {/* Right Column - Steps */}
              <div className="space-y-0">
                {steps.map((step, index) => (
                  <div
                    key={index}
                    className="flex gap-6 py-6 border-b border-neutral-100 group last:border-b-0"
                  >
                    <span className="text-xs font-mono text-neutral-400 pt-1">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <div>
                      <h4 className="text-lg font-medium text-neutral-900 mb-2 group-hover:text-yellow-600 transition-colors">
                        {step.title}
                      </h4>
                      <p className="text-sm text-neutral-500 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <div className="mb-16 mt-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-semibold text-neutral-900 tracking-tight mb-4">
              Mengapa Memilih Kami?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-14 h-14 bg-yellow-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <benefit.icon className="w-7 h-7 text-yellow-600" />
                </div>
                <h3 className="text-lg text-neutral-900 mb-2">{benefit.title}</h3>
                <p className="text-sm text-neutral-500">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="relative overflow-hidden rounded-2xl bg-neutral-900 p-8 lg:p-12">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-12 -right-12 w-64 h-64 bg-yellow-500 rounded-full blur-3xl" />
          </div>
          <div className="relative z-10 text-center">
            <h3 className="text-2xl lg:text-3xl text-white mb-4">
              Siap Menerbitkan Buku Anda?
            </h3>
            <p className="text-neutral-400 mb-8 max-w-xl mx-auto">
              Konsultasi gratis dengan tim editor kami untuk menentukan paket terbaik
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                asChild
                className="bg-yellow-500 hover:bg-yellow-400 text-white font-medium rounded-lg text-sm border-0 cursor-pointer"
              >
                <a href="/kontak" className="flex items-center justify-center">
                  <Phone className="w-4 h-4 mr-2" />
                  Konsultasi Gratis
                </a>
              </Button>
              <Button
                variant="outline"
                asChild
                className="bg-white/10 hover:bg-white/20 border border-white/20 text-white font-medium rounded-lg text-sm cursor-pointer"
              >
                <a href="/shop" className="flex items-center justify-center">
                  Lihat Portfolio
                  <ArrowRight className="w-4 h-4 ml-2" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}
